import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import "./TimeoutModal.css";

// Helper function to format seconds into HH:MM:SS
const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const pad = (num) => String(num).padStart(2, "0");

  return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
};

const TimeoutModal = ({ isVisible, countdown }) => {
  if (!isVisible) return null;

  return (
    <div className="timeout-overlay">
      <div className="timeout-modal">
        <div className="timeout-modal-header">
          <div className="timeout-modal-title">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="warning-icon"
            />
            <h2>Session Timeout Warning</h2>
          </div>
        </div>
        <div className="timeout-modal-content">
          <p>Your session will expire in:</p>
          <div className="countdown">
            <FontAwesomeIcon icon={faClock} className="clock-icon" />
            <span>{formatTime(countdown)}</span>
          </div>
          <p>Move your mouse or press any key to stay logged in.</p>
        </div>
      </div>
    </div>
  );
};

export default TimeoutModal;
